import React from 'react';

interface TitleBarProps {
  onSearch?: (query: string) => void;
}

export default function TitleBar({ onSearch }: TitleBarProps) {
  return (
    <header className="sticky top-0 left-0 w-full h-14 px-gutter flex justify-between items-center z-50 bg-surface-container-lowest border-b border-outline-variant select-none">
      <div className="font-headline-sm text-headline-sm font-bold text-on-surface">PVP Academy</div>
      {onSearch && (
        <div className="flex items-center gap-2 px-3 py-1.5 bg-surface-variant rounded-full text-on-surface-variant text-[12px]">
          <span className="material-symbols-outlined text-[16px]">search</span>
          <input
            type="text"
            placeholder="Search courses..."
            className="bg-transparent border-none outline-none text-on-surface text-[12px] p-0 w-32 focus:ring-0 focus:w-44 transition-all"
            onChange={(e) => onSearch(e.target.value)}
          />
        </div>
      )}
    </header>
  );
}
